// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".load-more{color:#5b615e;font-size:16px;display:table;font-weight:var(--weight-light);letter-spacing:0;line-height:23px;margin-block:43px 0;margin-inline:auto;cursor:pointer}.load-more>img{vertical-align:baseline;padding-inline-start:16px}@media(min-width: 960px){.load-more{margin-top:47px}}.load-less>img{transform:rotate(180deg);padding-inline:0 16px}", ""]);
// Exports
module.exports = exports;
